'use strict';

angular.module('imagetrend.components')
    .run(["$templateCache", function($templateCache) {
        $templateCache.put("time/timepicker.html",
          "<ul class=\"horizontal\">\n" +
          "    <li class=\"flex-row text-center\">\n" +
          "      <div class=\"\">\n" +
          "         <input type=\"text\" aria-label=\"Hours\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
          "      </div>\n" +
          "      <div class=\"align-center\">:</div>\n" +
          "      <div class=\"\">\n" +
          "         <input type=\"text\" aria-label=\"Minutes\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\">\n" +
          "      </div>\n" +
          "      <div class=\"\"><input type=\"button\" class=\"btn field text-center\" ng-click=\"toggleMeridian()\" ng-value=\"meridian\"/></div>\n" +
          "    </li>\n" +
          "</ul>\n" +
          "");
    }])
    .directive('hlpTime', ['Format', '$timeout', function (Format, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',

                //required
                isRequired: '=?',
                requiredText: '@?',

                //disabled
                isDisabled: '=?',

                //label
                showLabel: '@?',
                label: '@?',
                title: '@?',

                //instructions
                instructions: '@?'
            },
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/time/time.html',
            link: function (scope, elem, attrs, ctrl) {
                //attributes
                if (!attrs.name) { attrs.name = 'input'; }
                if (!attrs.id) { attrs.id = attrs.name; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                $timeout(function () {
                    if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)); }
                }, 0);

                //disabled
                if (scope.isDisabled == undefined) { scope.isDisabled = false; }

                scope.setTime = function () {
                    scope.onChange(scope.ngModel);
                }

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                }

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });
            }
        };
    }])
;